import { Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { I18nTranslator } from '../i18n/translate';

@Pipe({
  name: 't',
  standalone: true,
})
export class TranslatePipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(key: any, ...params: string[]): string {
    return this.i18nTranslator.translate(key, ...params);
  }
}

@Pipe({
  name: 'tp',
  standalone: true,
})
export class TranslateWithPunctuationPipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(key: any, punctuationMark: string, ...params: string[]): string {
    const t = this.i18nTranslator.translate(key, ...params);
    const punctuation = this.i18nTranslator.formatPunctuation(punctuationMark);
    return t + punctuation;
  }
}

@Pipe({
  name: 'tn',
  standalone: true,
})
export class TranslateNumberPipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(n: number): string {
    return this.i18nTranslator.formatNumber(n);
  }
}

@Pipe({
  name: 'td',
  standalone: true,
})
export class TranslateDatePipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(date: Date): string {
    if (typeof date === 'string') {
      return date as any;
    }
    return this.i18nTranslator.formatDate(date);
  }
}

@Pipe({
  name: 'tu',
  standalone: true,
})
export class TranslateUnitPipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(n: number, unit: string): string {
    return this.i18nTranslator.convertFromUnit(unit, n);
  }
}

@Pipe({
  name: 'tun',
  standalone: true,
})
export class TranslateUnitNamePipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(unit: string): string {
    return this.i18nTranslator.convertUnitName(unit);
  }
}

@Pipe({
  name: 'ti',
  standalone: true,
})
export class TranslateImageURLPipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(imageType: string, extension = '.png'): SafeUrl {
    return this.i18nTranslator.imageUrl(imageType, extension);
  }
}
